export const WISTIA_API = 'https://api.wistia.com/v1';
export const accessToken = process.env.REACT_APP_WISTIA_TOKEN;
export const WISTIA_PROJECT_API = 'https://fast.wistia.com/assets/external/api.js';
export const VIDEO_ACTION_TYPE = {
  create: 'CREATE',
  edit: 'EDIT',
};
